import { Box, Button, Typography } from "@mui/material";
import { useMemo, useState, useEffect } from "react";
import _ from "lodash";
import { getDataSource } from "api/ds";
import { ReportTable } from "components/reportTable";
import Loading from "components/Load";
import ClassicSearch from "./classicSearch";

export const ChooseProducts = ({ onCancel, onSelect, productsData, initialBarcode }) => {
    const [checked, setChecked] = useState(false);
    /** @type {[any, Function]} */ 
    const [filter, setFilter] = useState(null);
    const [hasInitialized, setHasInitialized] = useState(false); 

    /** @type {[any, Function]} */ 
    const [filterFields, setFilterFields] = useState({
        title: { name: "Название", active: true },
        brand: { name: "Брэнд", active: true },
        vendorCode: { name: "Артикул", active: true },
        barcode: { name: "ШК", active: true },
        size: { name: "Размер", active: true },
        color: { name: "Цвет", active: true },
    });

    /** @type {[Array<any>, Function]} */ 
    const [selectedIds, setSelectedIds] = useState([]);

    const descriptor = useMemo(() => {
        const ds = getDataSource('chooseProducts');
        if (!ds.descr) ds.descr = {};
        // Убираем принудительный singleSelect, если он блокирует снятие галочки
        // ds.descr.singleSelect = true; 
        return ds;
    }, []);

    const isDescriptorReady = useMemo(() => {
        return descriptor.descr && Array.isArray(descriptor.descr.items);
    }, [descriptor]);

    const flattenedData = useMemo(() => {
        if (!productsData || !Array.isArray(productsData)) return [];
        return productsData.map((pr) => {
            return {
                ...pr, 
                id: `${pr.nmID || pr.id}-${pr.size.barcode}`,
                currentBarcode: pr.size.barcode,
                currentSize: pr.size.techSize || pr.size.name
            }
        })
    }, [productsData]);

    // ЭФФЕКТ: Ставим галочку только при ПЕРВОМ открытии
    useEffect(() => {
        if (!hasInitialized && flattenedData.length > 0) {
            if (initialBarcode) {
                const preselectedRow = flattenedData.find(el => el.currentBarcode === initialBarcode);
                if (preselectedRow) {
                    setSelectedIds([preselectedRow.id]);
                }
            }
            setHasInitialized(true);
        }
    }, [flattenedData, initialBarcode, hasInitialized]);

    // Логика выбора/снятия галочки
    const handleTableSelect = (ids) => {
        if (ids.length === 0) {
            // Если массив пустой — значит, пользователь снял галочку
            setSelectedIds([]);
            return;
        }

        const lastId = ids[ids.length - 1];

        // Реализуем "переключатель": если кликнули по уже выбранному — снимаем
        if (selectedIds.length === 1 && selectedIds[0] === lastId) {
            setSelectedIds([]);
        } else {
            // Иначе выбираем новый элемент (сбрасывая старый, так как нам нужен один ШК)
            setSelectedIds([lastId]);
        }
    };

    const handleConfirm = () => {
        // Если массив пустой — отправляем пустую строку (очистка)
        if (selectedIds.length === 0) {
            onSelect(""); 
        } else {
            const selectedRow = flattenedData.find(el => el.id === selectedIds[0]);
            if (selectedRow?.currentBarcode) {
                onSelect(selectedRow.currentBarcode);
            }
        }
    };

    const filteredData = useMemo(() => {
        if (!checked || !filter) return flattenedData;
        const tf = filter.toLowerCase();
        return flattenedData.filter((el) => {
            return (
                (filterFields.title.active && String(el.data?.title || "").toLowerCase().includes(tf)) ||
                (filterFields.brand.active && String(el.data?.brand || "").toLowerCase().includes(tf)) ||
                (filterFields.vendorCode.active && String(el.data?.vendorCode || "").toLowerCase().includes(tf)) ||
                (filterFields.barcode.active && String(el.currentBarcode || "").toLowerCase().includes(tf)) ||
                (filterFields.size.active && String(el.currentSize || "").toLowerCase().includes(tf)) ||
                (filterFields.color.active && String(el.data?.color || "").toLowerCase().includes(tf))
            );
        });
    }, [flattenedData, checked, filter, filterFields]);

    
    console.log("flattenedData", flattenedData)
    console.log("filteredData", filteredData)

    return (
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', width: '100%' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', p: 2, borderBottom: '1px solid #eee' }}>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>Выбрать товар</Typography>
            </Box>

            <Box sx={{ display: 'flex', marginLeft: '30px' }}>
                <ClassicSearch
                    setChecked={setChecked}
                    setFilter={setFilter}
                    checked={checked}
                    // @ts-ignore
                    fields={filterFields}
                    // @ts-ignore
                    setFields={setFilterFields}
                />
            </Box>

            <Box sx={{ flex: 1, overflow: 'auto', p: 1 }}>
                {isDescriptorReady ? (
                    <ReportTable
                        ds={descriptor}
                        data={filteredData}
                        autoPagination={10}
                        inputSelected={selectedIds}
                        onSelect={handleTableSelect}
                    />
                ) : (
                    <Loading />
                )}
            </Box>

            <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end", p: 2, borderTop: '1px solid #eee' }}>
                <Button
                    onClick={onCancel}
                    variant="contained"
                    sx={{
                        textTransform: "none",
                        fontWeight: "bold",
                        px: 3,
                        backgroundColor: "grey.500",
                        "&:hover": { backgroundColor: "grey.600" },
                    }}
                >
                    Отмена
                </Button>
                <Button
                    onClick={handleConfirm}
                    variant="contained"
                    sx={{
                        textTransform: "none",
                        fontWeight: "bold",
                        px: 3,
                    }}
                >
                    {selectedIds.length > 0 ? "Добавить" : "Очистить"}
                </Button>
            </Box>
        </Box>
    );
};